﻿export async function DiagramAreaOfStudyHero() {
    let $toggle = $(".js-aos-toggle")
        , $target = $(".js-aos-toggle-target")
        ;

    $toggle.on('click', function (evt) {
        let $this = $(this);

        if ($this.hasClass('open')) {
            $this.removeClass('open');
            $target.removeClass('open');
        } else {
            $this.addClass('open');
            $target.addClass('open');
        }
    });
}